import { type ComponentProps } from 'react';

import {
	HoverCard as ArkHoverCard,
	type HoverCardRootProps as ArkHoverCardRootProps,
	Portal
} from '@ark-ui/react';

import { cn } from '../../lib/utils';

type HoverCardRootProps = ArkHoverCardRootProps;

function HoverCardRoot({ openDelay = 200, closeDelay = 150, ...props }: HoverCardRootProps) {
	return <ArkHoverCard.Root openDelay={openDelay} closeDelay={closeDelay} {...props} />;
}

function HoverCardTrigger({ className, ...props }: ComponentProps<typeof ArkHoverCard.Trigger>) {
	return <ArkHoverCard.Trigger className={cn('pt-hover-card-trigger', className)} {...props} />;
}

function HoverCardContent({ className, ...props }: ComponentProps<typeof ArkHoverCard.Content>) {
	return (
		<Portal>
			<ArkHoverCard.Positioner className="pt-hover-card-positioner">
				<ArkHoverCard.Content className={cn('pt-hover-card-content', className)} {...props} />
			</ArkHoverCard.Positioner>
		</Portal>
	);
}

const HoverCard = Object.assign(HoverCardRoot, {
	Root: HoverCardRoot,
	Trigger: HoverCardTrigger,
	Content: HoverCardContent
});

export { HoverCard, type HoverCardRootProps };
